import { useState } from "react";
import { Share2 } from "lucide-react";
import ShareSheet from "./ShareSheet";

/** Universal CONDIVIDI button. props: kind, card, share, caption, className, label, testid, size */
export default function ShareButton({ kind, card, share, caption, className = "", label = "CONDIVIDI", testid, variant = "outline" }) {
  const [open, setOpen] = useState(false);
  const base = variant === "solid" ? "btn-crimson" : variant === "ghost" ? "text-xs font-mono-rl text-[#FF9F0A] hover:text-white px-2" : "btn-outline-rl";
  return (
    <>
      <button onClick={(e) => { e.stopPropagation(); setOpen(true); }} className={`${base} inline-flex items-center gap-1.5 min-h-[44px] ${className}`} data-testid={testid || `share-${kind}-btn`}>
        <Share2 className="w-4 h-4" /> {label}
      </button>
      <ShareSheet open={open} onClose={() => setOpen(false)} kind={kind} card={card} share={share} caption={caption} />
    </>
  );
}
